import { 
    department_department_create,
    department_list_get,
    department_id_get,
    department_department_update
} from '../../Models/Management/Department_Model';

//======== CREATE ======
export const onCreateDepartment = (data) => {
    return new Promise((resolve, reject) => {
        department_department_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== GET ALL SHIFT =====
export const onGetDepartment = function (data) {
    return new Promise((resolve, reject) => {
        department_list_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

export const onGetDepartmentById = function (data) {
    return new Promise((resolve, reject) => {
        department_id_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}


//======== EDIT ========
export const onEditDepartment = (data) => {
    return new Promise((resolve, reject) => {
        department_department_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}


